import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  Icon,
  InputGroup,
  Stack,
  Switch,
  Text,
  Tooltip,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { BsFillInfoCircleFill } from 'react-icons/all';
import { Heading, Input } from '~/components';
import { useEmailConfigurationByType } from '~/hooks/useEmailConfiguration/useEmailConfiguration';

export class EmailsConfiguration {
  id!: number;

  tipo_configuracao!: number;

  status_cliente!: number;

  status_area!: number;

  enviar_email_cliente_em_dias!: number;

  repetir_email_cliente_em_dias!: number;

  enviar_email_area_em_dias!: number;

  repetir_email_area_em_dias!: number;
}

export const EmailControls: React.VFC<{
  title: string;
  tipoConfiguracao: number;
  saveForm: (e: EmailsConfiguration) => void;
}> = ({ title, saveForm, tipoConfiguracao }) => {
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    setError,
    formState,
    clearErrors,
    control,
  } = useForm();
  const { errors } = formState;
  const existeErros = Object.keys(errors).length;
  const [diasVencCliente, setDiasVencCliente] = useState<number>(0);
  const [diasRepetirCliente, setDiasRepetirCliente] = useState<number>(0);

  const [diasVencAreas, setDiasVencAreas] = useState<number>(0);
  const [diasRepetirAreas, setDiasRepetirAreas] = useState<number>(0);

  const [statusCliente, setStatusCliente] = useState<boolean>(false);
  const [statusArea, setStatusArea] = useState<boolean>(false);

  const [form, setForm] = useState<EmailsConfiguration>(
    new EmailsConfiguration(),
  );
  const { data, refetch } = useEmailConfigurationByType(tipoConfiguracao);

  useEffect(() => {
    setDiasVencCliente(data?.enviar_email_cliente_em_dias || 0);
    setDiasRepetirCliente(data?.repetir_email_cliente_em_dias || 0);
    setStatusCliente(data?.status_cliente === 1);
    setDiasVencAreas(data?.enviar_email_area_em_dias || 0);
    setDiasRepetirAreas(data?.repetir_email_area_em_dias || 0);
    setStatusArea(data?.status_area === 1);
    const updateForm = new EmailsConfiguration();
    updateForm.enviar_email_area_em_dias = data?.enviar_email_area_em_dias || 0;
    updateForm.enviar_email_cliente_em_dias =
      data?.enviar_email_cliente_em_dias || 0;
    updateForm.repetir_email_area_em_dias =
      data?.repetir_email_area_em_dias || 0;
    updateForm.repetir_email_cliente_em_dias =
      data?.repetir_email_cliente_em_dias || 0;
    updateForm.status_area = data?.status_area || 0;
    updateForm.status_cliente = data?.status_cliente || 0;
    updateForm.tipo_configuracao = tipoConfiguracao;
    data?.id && (updateForm.id = data?.id);
    setForm(updateForm);
  }, [data]);

  const handleStatusCliente = (event: any) => {
    setStatusCliente(event.target.checked);
    form.status_cliente = event.target.checked ? 1 : 0;
    !existeErros && saveForm(form);
  };

  const handleStatusArea = (event: any) => {
    setStatusArea(event.target.checked);
    form.status_area = event.target.checked ? 1 : 0;
    !existeErros && saveForm(form);
  };

  const handleDiasVencCliente = () => {
    form.enviar_email_cliente_em_dias = Number(diasVencCliente);
    !existeErros && saveForm(form);
  };
  const handleDiasRepetirCliente = () => {
    form.repetir_email_cliente_em_dias = Number(diasRepetirCliente);
    !existeErros && saveForm(form);
  };

  const handleDiasVencAreas = () => {
    form.enviar_email_area_em_dias = Number(diasVencAreas);
    !existeErros && saveForm(form);
  };
  const handleDiasRepetirAreas = () => {
    form.repetir_email_area_em_dias = Number(diasRepetirAreas);
    !existeErros && saveForm(form);
  };

  const validate = (campo: string, valor: number) => {
    if (valor > 999999999) {
      setError(`'${campo}'`, {
        type: 'max',
        message: 'Valor maior que o permitido.',
      });
    } else if (!/^[0-9]+$/.test(valor.toString())) {
      setError(`'${campo}'`, {
        type: 'pattern',
        message: 'Apenas números inteiros são permitidos.',
      });
    } else {
      clearErrors(`'${campo}'`);
    }
  };

  const getCampo = (tipo: number) => {
    if (tipo === 1) {
      return (
        <FormControl width="50%">
          <FormLabel htmlFor="writeUpFile" style={{ fontSize: '14px' }}>
            Enviar e-mail
          </FormLabel>
          <Text pt={2}>
            No dia seguinte à elegibilidade do contrato para extensão.
          </Text>
        </FormControl>
      );
    }
    return (
      <FormControl isInvalid={errors?.diasVencCliente} width="40%">
        <FormLabel htmlFor="writeUpFile" style={{ fontSize: '14px' }}>
          Enviar e-mail
        </FormLabel>
        <Input
          name="diasVencCliente"
          type="number"
          error={errors.diasVencCliente}
          fontSize="15px"
          placeholder="Dias"
          onBlur={handleDiasVencCliente}
          onChange={e => {
            setDiasVencCliente(Number(e.target.value));
            validate('diasVencCliente', Number(e.target.value));
          }}
          value={diasVencCliente}
        />
        <Text>dias antes do vencimento do contrato</Text>
      </FormControl>
    );
  };

  return (
    <>
      <Heading fontSize="lg">{title}</Heading>
      <Box p={4} border="1px solid #e5e5e6" borderRadius="8px">
        <FormControl
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Heading fontSize="md" color="purple.300" fontWeight="500" py={4}>
            Cliente
          </Heading>
          <Switch
            isChecked={statusCliente}
            id="email-cliente"
            colorScheme="green"
            onChange={handleStatusCliente}
          />
        </FormControl>
        <Flex
          flexDir="row"
          flexWrap="wrap"
          w="100%"
          gridGap="12"
          justify="space-between"
        >
          <Stack gridGap={2} width="100%">
            <InputGroup justifyContent="space-between">
              {getCampo(tipoConfiguracao)}
              <FormControl isInvalid={errors?.diasRepetirCliente} width="40%">
                <FormLabel
                  htmlFor="writeUpFile"
                  style={{ fontSize: '14px' }}
                  justifyContent="space-between"
                  display="flex"
                >
                  Repetir e-mail a cada
                  <Tooltip
                    hasArrow
                    label="A repetição deve ser de acordo com a menor faixa de tempo cadastrada."
                    bg="gray"
                    shouldWrapChildren
                  >
                    <Icon as={BsFillInfoCircleFill} />
                  </Tooltip>
                </FormLabel>
                <Input
                  name="diasRepetirCliente"
                  type="number"
                  error={errors.diasRepetirCliente}
                  fontSize="15px"
                  placeholder="Dias"
                  onBlur={handleDiasRepetirCliente}
                  onChange={e => {
                    setDiasRepetirCliente(Number(e.target.value));
                    validate('diasRepetirCliente', Number(e.target.value));
                  }}
                  value={diasRepetirCliente}
                />
                <Text>dias</Text>
              </FormControl>
            </InputGroup>
          </Stack>
        </Flex>

        <FormControl
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Heading
            fontSize="md"
            color="purple.300"
            fontWeight="500"
            pb={4}
            pt={8}
          >
            Áreas envolvidas
          </Heading>
          <Switch
            isChecked={statusArea}
            id="email-area"
            colorScheme="green"
            onChange={handleStatusArea}
          />
        </FormControl>
        <Flex
          flexDir="row"
          flexWrap="wrap"
          w="100%"
          gridGap="12"
          justify="space-between"
        >
          <Stack gridGap={2} width="100%">
            <InputGroup justifyContent="space-between">
              <FormControl isInvalid={errors?.diasVencAreas} width="40%">
                <FormLabel htmlFor="writeUpFile" style={{ fontSize: '14px' }}>
                  Enviar e-mail
                </FormLabel>
                <Input
                  name="diasVencAreas"
                  type="number"
                  error={errors.diasVencAreas}
                  fontSize="15px"
                  placeholder="Dias"
                  onBlur={handleDiasVencAreas}
                  value={diasVencAreas}
                  onChange={e => {
                    setDiasVencAreas(Number(e.target.value));
                    validate('diasVencAreas', Number(e.target.value));
                  }}
                />
                <Text>dias antes do vencimento do contrato</Text>
              </FormControl>
              <FormControl isInvalid={errors?.diasRepetirAreas} width="40%">
                <FormLabel
                  htmlFor="writeUpFile"
                  style={{ fontSize: '14px' }}
                  justifyContent="space-between"
                  display="flex"
                >
                  Repetir e-mail a cada
                  <Tooltip
                    hasArrow
                    label="A repetição deve ser de acordo com a menor faixa de tempo cadastrada."
                    bg="gray"
                    shouldWrapChildren
                  >
                    <Icon as={BsFillInfoCircleFill} />
                  </Tooltip>
                </FormLabel>
                <Input
                  name="diasRepetirAreas"
                  type="number"
                  error={errors.diasRepetirAreas}
                  fontSize="15px"
                  placeholder="Dias"
                  onBlur={handleDiasRepetirAreas}
                  value={diasRepetirAreas}
                  onChange={e => {
                    setDiasRepetirAreas(Number(e.target.value));
                    validate('diasRepetirAreas', Number(e.target.value));
                  }}
                />
                <Text>dias</Text>
              </FormControl>
            </InputGroup>
          </Stack>
        </Flex>
      </Box>
    </>
  );
};
